<template>
  <div class="page-wrapper">
    <div class="list">
      <!-- 专题详情含分类，点击查看更多-跳转-显示列表 -->
      <div class="subject-kind-list" v-if="type == 5">
          <!-- 普通专题 -->
          <div class="subject-topImg" v-if="sData">
              <div class="img" :style="{'background-image': 'url('+sData.imgUrl+')'}">
                <img style="opacity: 0" :src="sData.imgUrl" :onerror="errorTopImg">
              </div>
              <div class="text">
                  <div class="title">{{sData.name}}</div>
                  <p class="brief">{{sData.brief}}</p>
              </div>
          </div>
          <div class="classify-title">{{kindName}}</div>
          <NewsList v-if="list" :list="list" :type="2" :subjectId="id" :skId="skId" :columnId="id" :channelId="channelId" />
      </div>
      <!-- 文章栏目 -->
      <div class="article-list" v-else>
          <NewsList v-if="list" :list="list" :type="3" :columnId="id" :channelId="channelId" />
      </div>

      <div v-show="isLoading || lastDataId == -1 || subjectKindLastId == -1" class="loadMore">
        <div class="loadMoreInner">{{(lastDataId == -1 || subjectKindLastId == -1) ? '已经到底了' : '加载更多...'}}</div>
      </div>
    </div>
    <!-- <div class="wap-list">
    </div> -->
  </div>
</template>
<script>
import SubjectSpecial from "@/components/SubjectSpecial";
import NewsList from "@/components/NewsList";
import { mapState, mapMutations } from 'vuex';
export default {
  name: "subjectResult",
  data() {
    return {
      page: 1,
      list: [],
      isLoading: false,
      type: null, // 1-栏目文章列表
      id: null, // type == 5 --- 专题id，其他情况代表栏目id
      skId: null, // 专题分类列表id
      lastDataId: null, // 1 文章
      subjectList: null,
      subjectKindLastId: null, // 5 分类专题新闻列表lastId
      topImg: null, // 专题分类头图
      kindName: '', // 专题分类名称
      errorTopImg: `this.parentNode.style.backgroundImage = 'url("${require('./../assets/img/default.png')}")'`, // 分类专题头图加载失败
      sData: null,
      channelId:''
    };
  },
  components: {
    SubjectSpecial,
    NewsList
  },
  // created() {
  //   // 5 为专题  不是5的话  传过来是频道id
  //   this.type = this.$Common.Base64.decode(this.$route.params.type);
  //   this.id = this.$route.params.id;
  //   this.skId = this.$route.params.skId;
  //   if(this.$route.params.type == 5){
  //     this.setIsSubject(true);
  //   }else{
  //     this.channelId = this.$Common.Base64.decode(this.$route.params.type)
  //   }
  //   this.getTitle(); // document.title
  //   this.getData(true); // 为true代表第一次请求
  // },
  mounted() {
    // 5 为专题  不是5的话  传过来是频道id
    this.type = this.$Common.Base64.decode(this.$route.params.type);
    this.id = this.$route.params.id;
    this.skId = this.$route.params.skId;
    if(this.$route.params.type == 5){
      this.setIsSubject(true);
    }else{
      this.channelId = this.$Common.Base64.decode(this.$route.params.type)
    }
    this.getTitle(); // document.title
    this.getData(true); // 为true代表第一次请求
    this.isPhone && this.$Common.onShare({
      shareTitle: '四川互联网举报辟谣平台',
      shareUrl: window.location.href
    })
  },
  updated() {
    // 5 为专题  不是5的话  传过来是频道id
    this.type = this.$Common.Base64.decode(this.$route.params.type);
    this.id = this.$route.params.id;
    this.skId = this.$route.params.skId;
    if(this.$route.params.type == 5){
      this.setIsSubject(true);
    }else{
      this.channelId = this.$Common.Base64.decode(this.$route.params.type)
    }
  },
  methods: {
    ...mapMutations(['setLoadingShow','setIsSubject','setIsSpecial']),
    getData(flag) {
        if(this.lastDataId == -1 || this.subjectKindLastId == -1) {
          return;
        }
        if(this.isLoading) {
          return;
        }
        this.isLoading = true;
        if(this.type == 5) {
          this.getSubjectNews(flag);
        } else {
          this.getColumnNews(flag);
        }
    },
    getColumnNews(flag) {
      if(this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
        return;
      }
      const params = {
        channelId: this.$Common.Base64.decode(this.$route.params.type),
        pageSize: this.isPhone ? 20 : 45,
        queryType: 2,
        queryAllImg: true
      }
      if (this.lastDataId) {
        params.lastDataId = this.lastDataId
        params.lastDataType = 0
      }
      // if(this.isPhone) params.queryAllImg = true
      this.$axios.post(this.$ApiInfo.getChannelItemList, params).then(res => {
        if (res.channel) {
          document.title = res.channel.id == 100 ? '四川互联网举报辟谣平台' : this.colums.find(v => v.channelId == res.channel.id).name
        }
        this.lastDataId = res.lastDataId;
        this.list = this.list.concat(res.list);
        this.isLoading = false;
        flag && this.setLoaing()
      })
    },
    getSubjectNews(flag) {
      if(this.subjectKindLastId == -1 || !this.$Common.Base64.decode(this.id) || !this.$Common.Base64.decode(this.skId)) {
        return;
      }
      const params = {
          subjectId: this.$Common.Base64.decode(this.id),
          skId: this.$Common.Base64.decode(this.skId),
          pageSize: this.pageSize,
        }
        if (this.subjectKindLastId) {
          params.lastDataId = this.subjectKindLastId;
        }
        if(this.isPhone) params.queryAllImg = true
      this.$axios.post(this.$ApiInfo.getSubjectDetail, params).then(res => {
        this.isPhone && res.share && this.$Common.onShare({
            shareTitle: res.share.shareTitle,
            shareBrief: res.share.shareBrief,
            shareUrl: window.location.href,
            // shareImg: res.share.shareImg
        })
        if (res.subject){
          this.sData = res.subject;
        }
        this.list = this.list.concat(res.subjectKindList[0].list);
        this.subjectKindLastId = res.subjectKindList[0].lastDataId;
        this.kindName = res.subjectKindList[0].name;
        this.isLoading = false;
        this.setLoadingShow(false)
        flag && this.setLoaing()
      })
    },
    setInit() {
      this.page = 1;
      this.list = [];
      this.isLoading = false;
      this.type = null;
      this.id = null;
      this.skId = null;
      this.lastDataId = null;
      this.subjectList = null;
      this.subjectKindLastId = null;
      this.topImg = null;
      this.kindName = '';
      this.sData = null;
    },
    getTitle() {
      if(this.$route.params.type == 1 || this.$route.params.type == 3) {
        this.columnList && this.columnList.length && this.columnList.map(v => {
          if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
            document.title = v.name;
          }
        })
      }
    },
    setLoaing() {
      this.setLoadingShow(false)
      this.$nextTick(() => {
        let footerHeight = 0;
        document.querySelector('.footer-wrapper') && document.querySelector('.footer-wrapper').clientHeight > 0 && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 50)
        this.$Common.loadScroll(footerHeight, this.getData);
      })
    }
  },
  computed: {
    ...mapState(['columnList']),
    isPhone() {
        return this.$Common.Attribute.isMb();
    },
    pageSize() {
      return this.isPhone ? 20 : 45;
    },
    colums() {
      return this.columnList;
    },
  },
  watch: {
    $route(val) {
      if(val.params && (val.params.type != this.type || val.params.id != this.id)) {
        this.setInit();
        this.type = val.params.type;
        this.id = val.params.id;
        this.skId = val.params.skId;
        this.getData(true);
        this.getTitle();
      }
    },
    colums(val) {
      if(this.$route.params.type == 1 || this.$route.params.type == 3) {
        val && val.length && val.map(v => {
          if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
            document.title = v.name;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.subject-kind-list {
  .subject-topImg {
     width: 100%;
        height: auto;
        margin-bottom: 1.5rem;
        .img {
            display: block;
            width: 100%;
            height: 12.75rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-image: url('./../assets/img/default.png');
        }
        .text {
            padding: 1.25rem 1.5625rem;
            background: #fff;
            color: #333333;
            .title {
                font-size: 1.375rem;
                line-height: 1.875rem;
            }
            .brief {
                font-size: 1.25rem;
                line-height: 1.75rem;
            }
        }
  }
  .classify-title {
      color: #006df1;
      border-left: 0.1875rem solid #006df1;
      text-indent: .5em;
      margin-bottom: 0.875rem;
      line-height: 1.125rem;
      &.isSpecial{
        color: #385C40;
        border-left: 0.1875rem solid #385C40; 
      }
      // .title {
      //     float: left;
      // }
  }
}

.wap-wrapper {
  .subject-kind-list {
    .subject-topImg {
      display: none;
      .text {
        width: 100%;
        box-sizing: border-box;
        padding: 6.8vw 4vw 4.4vw;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
        color: #fff;
        position: absolute;
        bottom: 0;
        .title {
            display: none;
        }
        .brief {
            font-size: 4.533vw;
            line-height: 6.4vw;
        }
      }
    }
    .classify-title {
        display: none;
    }
  }
}
.subject-message {
  margin-top: 0.625rem;
  margin-bottom: 1.5rem;
  color: #fff;
  .subject-message-title {
    font-size: 1.125rem;
    line-height: 1.5625rem;
    border-bottom: 0.125rem solid #fff;
    padding-bottom: 0.25rem;
  }
}
.no-subject-result {
  color: #fff;
}
</style>